import React, { lazy } from 'react'

const HomePage = lazy(() => import('./HomePage'))

export { HomePage }
